export default function InnovationSection() {
  return (
    <section
      className="w-full bg-background-50 py-24 px-6 md:px-10 lg:px-16"
      aria-label="Innovation statement"
    >
      <div className="max-w-[1100px] mx-auto">
        <div className="relative bg-foreground-950 rounded-[32px] overflow-visible px-12 md:px-20 py-20 md:py-24">
          <div className="absolute -left-6 top-1/2 -translate-y-1/2 select-none pointer-events-none z-0 hidden lg:block">
            <span className="font-heading text-[15rem] leading-none text-accent-200/15 italic">
              &ldquo;
            </span>
          </div>
          <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16 relative z-10">
            <div className="hidden lg:flex items-center justify-center shrink-0 w-16">
              <span className="font-heading text-[6rem] leading-none text-accent-200/50 italic">
                &ldquo;
              </span>
            </div>
            <div className="flex-1">
              <p className="font-body text-xl md:text-[1.6rem] lg:text-[1.75rem] text-background-50 leading-relaxed max-w-[38rem] font-light">
                We believe in continuous innovation, steady refinement of development workflows, 
                and the adoption of up-to-date engineering standards. Technical excellence is not 
                a destination but a practice we commit to every day.
              </p>
              <div className="mt-16">
                <p className="font-label text-sm text-foreground-400 tracking-wide">
                  Committed to long-term quality and reliability
                </p>
                <p className="font-label text-sm text-foreground-500 tracking-wide mt-1">
                  Future-ready solutions built with care
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}